import { getWxToken, setWxToken, removeWxToken } from '@/utils/auth'
import Cookies from 'js-cookie'
const state = {
  wxtoken: getWxToken(),
  nickname: Cookies.get('nickname'),
  avatar: Cookies.get('avatar'),
  wxuserid: Cookies.get('wxuserid')
}

const mutations = {
  SET_WXTOKEN(state, token) {
    state.wxtoken = token
  },
  REMOVE_WXTOKEN(state) {
    state.wxtoken = ''
  },
  SET_WXUSERINFO(state, WxUserInfo) {
    state.nickname = WxUserInfo.NickName
    state.avatar = WxUserInfo.Avatar
    state.wxuserid = WxUserInfo.Id
    Cookies.set('nickname', WxUserInfo.NickName)
    Cookies.set('avatar', WxUserInfo.Avatar)
    Cookies.set('wxuserid', WxUserInfo.Id)
  },
  REMOVE_WXUSERINFO(state) {
    state.nickname = ''
    state.avatar = ''
    Cookies.remove('nickname')
    Cookies.remove('avatar')
    Cookies.remove('wxuserid')
  }
}

const actions = {
  setWxToken({ commit }, token) {
    return new Promise(resolve => {
      setWxToken(token)
      commit('SET_WXTOKEN', token)
      resolve()
    })
  },
  removeWxToken({ commit }) {
    return new Promise(resolve => {
      removeWxToken()
      commit('REMOVE_WXTOKEN')
      resolve()
    })
  },
  setWxUserInfo({ commit }, WxUserInfo) {
    return new Promise(resolve => {
      commit('SET_WXUSERINFO', WxUserInfo)
      resolve()
    })
  },
  removeWxUserInfo({ commit }) {
    return new Promise(resolve => {
      commit('REMOVE_WXUSERINFO')
      resolve()
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/wxuser.js